import React, { FC } from 'react'
import FbImageLibrary from '../../../FbImageLibrary'

import MessageField from '../../PostEditor/UI/MessageField'
import LinkPreview from '../../PostEditor/UI/LinkPreview'
import MultiLinkCarousel from '../../PostEditor/UI/MultiLinkCarousel'
import Ellipsis from '../../../UI/Icons/Ellipsis'
import Like from '../../../UI/Icons/Like'
import Comments from '../../../UI/Icons/Comments'
import Share from '../../../UI/Icons/Share'

import {
  TAttachmentIds,
  TChangeAttachmentExtrafieldPayload,
  TPostSocialManagePost,
  TRemoveAttachmentPayload
} from '../../../../store/managePost/newTypes'
import { TSocialDetails } from '../../../../selectors/ProjectSelector'
import { SOCIAL_NETWORK } from '../../../../models/post'
import { ImageType } from 'react-images-uploading/dist/typings'

import './FacebookPreview.scss'
import VideoPreview from '../../../UI/VideoPreview'
import LoadableImage from '../../../UI/LoadableImage'

interface FacebookPreviewProps {
  isMokup?: boolean
  socialPost: TPostSocialManagePost
  isMobile?: boolean
  restrictions: any
  socialDetails: TSocialDetails
  publishDate: string
}

const FacebookPreview: FC<FacebookPreviewProps> = ({
  isMokup,
  restrictions,
  socialPost,
  isMobile = false,
  publishDate,
  socialDetails
}) => {
  return (
    <div
      className={`post-preview facebook-preview ${isMokup && 'mokup'} ${isMobile && 'mobile-view'}`}
    >
      <div className='facebook-content'>
        <div className='facebook-content__customer'>
          <div className='facebook-content__customer__avatar'>
            {socialDetails[SOCIAL_NETWORK.FACEBOOK_SOCIAL].logo.original ? (
              <LoadableImage media={socialDetails[SOCIAL_NETWORK.FACEBOOK_SOCIAL].logo.original!} />
            ) : (
              socialDetails[SOCIAL_NETWORK.FACEBOOK_SOCIAL].logo.default
            )}
          </div>
          <div className='facebook-content__customer__data'>
            <div className='facebook-content__customer__data__name'>
              {socialDetails[SOCIAL_NETWORK.FACEBOOK_SOCIAL]!.name}
            </div>
            <div className='facebook-content__customer__data__last-seen'>{publishDate} &#xB7;</div>
          </div>
          <div className='facebook-content__customer__etc'>
            <Ellipsis />
          </div>
        </div>
        <div className='facebook-content__content'>
          {socialPost.message && (
            <MessageField
              {...{
                social: socialPost.social_network,
                editorRaws: socialPost.message_editor_state,
                value: socialPost.message,
                className: 'facebook-content__content'
              }}
            />
          )}
          {restrictions.link && !restrictions.cards && (
            <LinkPreview
              {...{ attachment: socialPost.attachments[0], isEditable: socialPost.isEditable }}
            />
          )}
          {restrictions.cards && (
            <MultiLinkCarousel
              {...{
                attachments: socialPost.attachments,
                refMediaCallbaks: {} as any,
                addLinkToAttachments: (isChildLink: boolean) => {},
                setCarouselActiveAttachmentIds: (ids: TAttachmentIds) => {},
                linkCarouselSelectedAttachmentIds: { id: 0, temporaryId: 0 },
                restrictions,
                deattachAttachment: (data: TRemoveAttachmentPayload) => {},
                setExtraField: (data: TChangeAttachmentExtrafieldPayload) => {},
                addMediaToTemporaryLibrary: (data: ImageType, ids: TAttachmentIds) => {},
                deleteMediaFromPostSocial: (id: TRemoveAttachmentPayload) => {},
                isEditable: false,
                logo: socialDetails[SOCIAL_NETWORK.FACEBOOK_SOCIAL]!.logo
              }}
            />
          )}
        </div>
      </div>
      {restrictions.mediaRestrictions.image && !!socialPost.attachments.length && (
        <div className='facebook__images'>
          <FbImageLibrary
            hideOverlay={true}
            images={socialPost.attachments
              .filter(({ object_data }) => !!object_data)
              .map(({ object_data }) => object_data!)}
            isEditable={false}
          />
        </div>
      )}
      {restrictions.mediaRestrictions.video && !!socialPost.attachments.length && (
        <div className='facebook__videos'>
          <VideoPreview
            attachment={socialPost.attachments[0]}
            width={isMokup ? 125 : 300}
            className='facebook__videos__video'
          />
        </div>
      )}
      <div className='facebook__motion-wrapper'>
        <div className='facebook__motion-wrapper__icon'>
          <Like color='#9C9EB2' /> Like
        </div>
        <div className='facebook__motion-wrapper__icon'>
          <Comments color='#9C9EB2' /> Comment
        </div>
        <div className='facebook__motion-wrapper__icon'>
          <Share color='#9C9EB2' /> Share
        </div>
      </div>
      {socialPost && socialPost?.first_comment?<div className='facebook-first-comments'>
              <div className='title'>First Comments</div>
              <div className='value'>{socialPost.first_comment}
              </div>
            </div>:null}
    </div>
  )
}

export default FacebookPreview
